import { cn } from '@/lib/utils';
import getAvatarColor from '@/utils/getAvatarColor';
import CustomerAvatar from '@/components/customers/CustomerAvatar';

// Renders two overlapping customer photos/initials for a group conversation. When more
// than two participants exist, the second circle shows a "+N" overflow count.
export default function GroupAvatar({ customers = [], business, className }) {
  const participants = (customers || []).filter(Boolean);
  const first = participants[0];
  const second = participants[1];
  const overflow = participants.length - 2;

  const firstName = first?.name || first?.phone || '';
  const secondName = second?.name || second?.phone || '';

  return (
    <div className={cn('relative size-8 shrink-0', className)}>
      <CustomerAvatar
        customer={first && { ...first, _business: first._business || business }}
        fallbackName={firstName}
        colorSeed={firstName || 'group'}
        className="absolute left-0 top-0 size-5 border-2 border-background"
        fallbackClassName="text-[9px]"
      />
      {overflow > 0 ? (
        <div
          className="absolute bottom-0 right-0 flex size-5 items-center justify-center rounded-full border-2 border-background text-[9px] font-semibold text-white"
          style={{ backgroundColor: getAvatarColor(secondName || `${firstName}-2`) }}
        >
          {`+${overflow}`}
        </div>
      ) : (
        <CustomerAvatar
          customer={second && { ...second, _business: second._business || business }}
          fallbackName={secondName}
          colorSeed={secondName || `${firstName}-2`}
          className="absolute bottom-0 right-0 size-5 border-2 border-background"
          fallbackClassName="text-[9px]"
        />
      )}
    </div>
  );
}
